import registry from './registry.json'
import './product-icons.css'

// Named sizes: inline sits next to text, standalone stands on its own. A
// number is a pixel size, kept for artwork that predates the named sizes.
const SIZES = { inline: 'var(--app-icon-inline, 16px)', standalone: 'var(--app-icon, 20px)' }

// The registry contains artwork, never a list of enabled integrations or capabilities.
export default function ProductIcon({ name = 'ui/app-window', size = 'inline', label, className = '' }) {
  const asset = registry[name] || registry['ui/app-window']
  const dimension = SIZES[size] ?? size
  const style = { width: dimension, height: dimension }
  return asset.mask
    ? <span className={`product-icon product-icon--mask ${className}`} style={{ ...style, maskImage: `url("${asset.src}")`, WebkitMaskImage: `url("${asset.src}")` }} role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true} />
    : <img className={`product-icon ${className}`} style={style} src={asset.src} alt={label || ''} aria-hidden={label ? undefined : true} />
}

export function microsoftCapabilityIcon(instance) {
  const stem = (instance.bundle || instance.instanceId || '').replace(/-(read|write)$/, '')
  return registry[`microsoft/${stem}`] ? `microsoft/${stem}` : 'ui/app-window'
}

// Only a service URL establishes a brand; a user-chosen display name does not.
export function serviceIconForUrl(value, fallback = 'ui/app-window') {
  try {
    const host = new URL(value).hostname.toLowerCase()
    if (host === 'claude.ai') return 'brand/claude'
    if (host === 'antigravity.google') return 'brand/googleantigravity'
    if (host === 'chatgpt.com' || host === 'openai.com') return 'brand/openai'
    if (host === 'api.deepseek.com') return 'brand/deepseek'
  } catch { /* Missing or invalid service URL: show the generic type icon. */ }
  return fallback
}
